export const sendVerificationCode = (
  values,
  successCallback,
  errorCallback
) => {
  const data = new FormData()
  data.append('vPhone', values.phone)
  data.append('type', 'signup')
  data.append('send_sms', 'true')
  data.append('language', values.language)

  fetch('/signup/send_verification_code', {
    method: 'POST',
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: data
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        if (typeof (successCallback) === 'function') { successCallback(data) }
      }
      if (data.errors) {
        if (typeof (errorCallback) === 'function') { errorCallback(data) }
      }
    })
}

export const submitVerificationCode = (values, successCallback, errorCallback) => {
  const data = new FormData()
  data.append('vPhone', values.phone)
  data.append('verify_code', values.verificationCode)
  data.append('type', 'signup')
  data.append('language', values.language)
  data.append('tries', values.tries)

  fetch('/signup/verify_user', {
    method: 'POST',
    referrerPolicy: 'no-referrer',
    body: data
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        if (typeof (successCallback) === 'function') { successCallback(data) }
      }
      if (data.errors) {
        if (typeof (errorCallback) === 'function') { errorCallback(data) }
      }
    })
}
